import {Button, Drawer, DrawerProps, Stack, SxProps, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../i18n/translations';

const drawerFormSx: SxProps = {
  width: {xs: '300px', sm: '356px'},
  maxHeight: '100vh',
  flexGrow: 1,
  alignItems: 'center',
};

const titleSx: SxProps = {
  fontSize: '18px',
  fontWeight: 500,
  lineHeight: '24px',
  letterSpacing: '0.225px',
  marginTop: '24px',
  color: 'var(--dcm-gray)',
  flexShrink: 0,
};

const contentSx: SxProps = {
  width: '100%',
  flexGrow: 1,
  padding: '20px',
  overflowY: 'auto',
};

const actionsContainerSx: SxProps = {
  width: '100%',
  flexShrink: 0,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '20px',
  borderTop: '2px solid var(--dcm-blue-light)',
};

const buttonSx: SxProps = {
  fontSize: '18px',
  padding: '10px 16px',
  fontWeight: '500 !important', // Overrides the "contained" 700 !important
  lineHeight: '24px',
  letterSpacing: '0.225px',
  textTransform: 'capitalize',
};

// Set a custom onDrawerClose event instead so we can make the drawer closing logic self-contained.
export interface ActionsDrawerProps extends Omit<DrawerProps, 'onClose'> {
  title: string;
  onClearClick: () => void;
  onSaveClick: () => void;
  onDrawerClose: () => void;
}

const ActionsDrawer = ({
  onClearClick,
  onSaveClick,
  onDrawerClose,
  title,
  open,
  children,
  ...rest
}: ActionsDrawerProps) => {
  const {t} = useTranslation();

  return (
    <Drawer anchor="right" open={open} onClose={onDrawerClose} {...rest}>
      <Stack component="form" sx={drawerFormSx}>
        <Typography sx={titleSx}>{title}</Typography>
        <Stack sx={contentSx} gap={1.5}>
          {children}
        </Stack>
        <Stack sx={actionsContainerSx}>
          <Button
            color="error"
            sx={{...buttonSx, color: 'var(--dcm-red-base)'}}
            onClick={onClearClick}
          >
            {t(translations.daily_care_log.task_table.drawer.clear)}
          </Button>
          <Button variant="contained" sx={buttonSx} onClick={onSaveClick}>
            {t(translations.daily_care_log.task_table.drawer.save)}
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
};

export default ActionsDrawer;
